import type { ReactNode } from "react";
import { ChevronRight } from "lucide-react";

/*
 * O painel recolhível: `<details>` nativo, e não um colapsável de biblioteca.
 *
 * O navegador já resolve teclado, estado para leitor de tela e a busca da página
 * dentro do conteúdo fechado (design D17). O convênio usa dois, "Dados" e
 * "Configurações", no padrão dos dois painéis da GUI da TecnoSpeed.
 */
export function PainelRecolhivel({
  titulo,
  abertoAoIniciar = true,
  children,
}: {
  titulo: string;
  abertoAoIniciar?: boolean;
  children: ReactNode;
}) {
  return (
    <details open={abertoAoIniciar} className="group rounded-controle border border-fio">
      <summary className="flex cursor-pointer list-none items-center gap-1 rounded-controle px-3 py-2 hover:bg-superficie-2 [&::-webkit-details-marker]:hidden">
        <ChevronRight
          aria-hidden="true"
          className="size-3.5 text-texto-2 transition-transform group-open:rotate-90 motion-reduce:transition-none"
        />
        <span className="rotulo">{titulo}</span>
      </summary>

      <div className="flex flex-col gap-2 border-t border-fio p-3">{children}</div>
    </details>
  );
}
